import axios from "axios";
import { ApiUrl, Endpoints } from '../data/global.js';
import * as global from '../data/global.js';
import { fetchSwitch } from './apiClient.js';

const SITE_SETUP_FETCH_TIMEOUT_MS = 120000;
const SITE_SETUP_BTS_EXPORT_TIMEOUT_MS = 600000;

/** Unwrap GraphQL string / nested JSON from fetchSiteSetup into a normalized setup object. */
function parseSiteSetupPayload(raw) {
    if (raw == null || raw === false) {
        return { ok: false, error: "Failed to load site setup. Confirm the server is deployed with fetchSiteSetup." };
    }

    let parsed = raw;
    for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
        try {
            parsed = JSON.parse(parsed);
        } catch (parseErr) {
            return { ok: false, error: `Invalid setup response: ${parseErr.message}` };
        }
    }

    if (parsed?.data?.fetchSiteSetup != null) {
        return parseSiteSetupPayload(parsed.data.fetchSiteSetup);
    }

    if (parsed?.error) {
        return { ok: false, error: String(parsed.error) };
    }

    let setup = parsed?.setup ?? parsed?.Setup ?? parsed;
    if (typeof setup === "string") {
        try {
            setup = JSON.parse(setup);
        } catch (parseErr) {
            return { ok: false, error: `Invalid setup payload: ${parseErr.message}` };
        }
    }

    const main = setup?.main ?? setup?.Main;
    if (!main) {
        return { ok: false, error: "Site setup response did not include main configuration." };
    }

    return {
        ok: true,
        siteGuid: parsed?.siteGuid ?? parsed?.SiteGuid ?? null,
        setup: {
            main,
            devices: setup.devices ?? setup.Devices ?? [],
            modules: setup.modules ?? setup.Modules ?? [],
            sections: setup.sections ?? setup.Sections ?? [],
            sectionPositionRefs: setup.sectionPositionRefs ?? setup.SectionPositionRefs ?? [],
            bins: setup.bins ?? setup.Bins ?? [],
            fans: setup.fans ?? setup.Fans ?? [],
            cables: setup.cables ?? setup.Cables ?? [],
            sensors: setup.sensors ?? setup.Sensors ?? [],
            tasks: setup.tasks ?? setup.Tasks ?? [],
        },
    };
}

export const createApiEndpoint = (ep) => {
    return {
        fetchUser: async (email) => {
            global.gw.isAlphaModalOpen = true;
            let data = new FormData();
            data.append("email", email);
            let userExists = await axios({
                url: `${ApiUrl}${Endpoints.Email}`,
                method: 'post',
                timeout: 10000, // 10 second timeout
                // httpsAgent: HTTPSAGENT,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: data
            }).then(function (response) {
                if (response.data.bolts) {
                    global.gw.email = email.toLowerCase().trimEnd();
                    global.gw.bolts = response.data.bolts;
                    return true;
                }
                else {
                    //global.gw.email = null;
                    //global.gw.bolts = null;
                    return false;
                }
            })
                .catch(function (error) {
                    // console.log(error);
                    return false;
                });
            return userExists;
        },
        fetchLogin: async (wall) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts)
                return null;

            let encrypted = await global.encryptMessageOutAsync(wall, 4096, 4096, 512);

            let data = new FormData();
            data.append("email", global.gw.email);
            data.append("value", encrypted);

            let userExists = await axios({
                url: `${ApiUrl}${Endpoints.Login}`,
                method: 'post',
                timeout: 10000, // 10 second timeout
                // httpsAgent: HTTPSAGENT,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: data
            }).then(function (response) {
                let result = false;
                let json = response.data;
                if (json &&
                    json.value &&
                    json.value !== "") {
                    try {
                        const decrypted = global.decryptMessageIn(response);
                        const v = decrypted.Value;
                        global.gw.profileUser = v.first ?? v.First;
                        const roles = v.roles ?? v.Roles;
                        global.gw.roles = Array.isArray(roles) ? roles : ['User'];
                        const access = v.token ?? v.Token;
                        const rt = v.refreshToken ?? v.RefreshToken;
                        result = access
                            ? (rt ? access + "|" + rt : access)
                            : false;
                    } catch (e) {
                        result = false;
                    }
                }

                //if (!result) {
                //    global.gw.email = null;
                //    global.gw.bolts = null;
                //}

                return result;
            })
                .catch(function (error) {
                    return false;
                });
            return userExists;
        },
        fetchRefresh: async (token, refreshToken) => {
            //if (!global ||
            //    !global.gw ||
            //    !global.gw.email ||
            //    !global.gw.bolts)
            //    return null;

            //let splits = global.gw.bolts.split("|");

            //if (!splits || splits.length !== 2)
            //    return null;

            //let skey = await window.crypto.subtle.generateKey(
            //    {
            //        name: "RSASSA-PKCS1-v1_5",
            //        modulusLength: 4096,
            //        publicExponent: new Uint8Array([1, 0, 1]),
            //        hash: "SHA-256",
            //    },
            //    true,
            //    ["sign", "verify"]
            //);

            //let bolts = token + "|" + global.gw.nuts.exportKey("pkcs8-public-pem");

            //let enc = new TextEncoder().encode(bolts);

            //let signature = await window.crypto.subtle.sign(
            //    {
            //        name: "RSASSA-PKCS1-v1_5",
            //    },
            //    skey.privateKey,
            //    enc
            //);

            //let publicKey = await crypto.subtle.exportKey("spki", skey.publicKey);
            //let pub = global.arrayBufferToBase64String(publicKey);

            //let signatureBase64 = global.arrayBufferToBase64String(enc) + "|" + global.arrayBufferToBase64String(signature) + "|" + pub;

            //const key = new nodeRSA();
            //key.importKey({
            //    n: Buffer.from(global.base64StringToArrayBuffer(splits[0])),
            //    e: 65537,
            //}, 'components-public');
            //let encrypted = key.encrypt(signatureBase64, "base64");

            let data = new FormData();
            data.append("token", token);
            data.append("refreshToken", refreshToken);

            let userExists = await axios({
                url: `${ApiUrl}${Endpoints.Refresh}`,
                method: 'post',
                timeout: 10000, // 10 second timeout
                // httpsAgent: HTTPSAGENT,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: data
            }).then(function (response) {
                let result = false;
                if (response.data &&
                    response.data.token &&
                    response.data.token !== "") {
                    try {
                        const roles = response.data.roles;
                        if (global.gw) {
                            global.gw.roles = Array.isArray(roles) ? roles : (global.gw.roles || ['User']);
                        }
                        const rt = response.data.refreshToken;
                        result = rt ? (response.data.token + "|" + rt) : response.data.token;
                    } catch (e) {
                        result = false;
                    }
                }

                if (!result) {
                    //global.gw.email = null;
                    //global.gw.bolts = null;
                }

                return result;
            })
                .catch(function (error) {
                    if (global.gw.test) {
                        // console.log(error.message);
                    }

                    return false;
                });
            return userExists;
        },
        fetchRenew: async () => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts)
                return null;

            let encrypted = await global.encryptMessageOutAsync(global.gw.auth, 4096, 4096, 512);

            let data = new FormData();
            data.append("email", global.gw.email);
            data.append("value", encrypted);

            let userExists = await axios({
                url: `${ApiUrl}${Endpoints.Renew}`,
                method: 'post',
                timeout: 10000, // 10 second timeout
                // httpsAgent: HTTPSAGENT,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: data
            }).then(function (response) {
                let result = false;
                if (response.data &&
                    response.data.value &&
                    response.data.value !== "") {
                    try {
                        let json = global.decryptMessageIn(response);
                        global.gw.token = json.Value.token;
                        global.gw.auth = json.Value.refreshToken || json.Value.auth;
                        const roles = json.Value.roles;
                        global.gw.roles = Array.isArray(roles) ? roles : ['User'];
                        result = true;
                    } catch (e) {
                        result = false;
                    }
                }

                return result;
            })
                .catch(function (error) {
                    return false;
                });
            return userExists;
        },
        fetchUserSites: async (output) => {
            // Check for required data - email and either bolts OR token/auth
            // bolts is only needed during initial login flow, token/auth are used after login
            if (!global ||
                !global.gw ||
                !global.gw.email) {
                // console.error('fetchUserSites: Missing email');
                return false;
            }
            
            // Compressed channel needs RSA bolts; Bearer `/api/gw` only needs access token (refresh `auth` optional).
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }

            let query = {
                query: `
                query FetchUserAttribute($email: String!, $value: String!) {
                    fetchUserAttribute(email: $email, value: $value) {
                        sites {
                            siteGuid,
                            currentTemperature,
                            currentHumidity,
                            currentPressure,
                            isHms,
                            isCcr,
                            main {
                                siteName,
                                emailReportTo,
                            },
                            bins {
                                binId,
                                name,
                                lowTemperature,
                                averageTemperature,
                                highTemperature,
                            },
                            cables {
                                id,
                                binId,
                                name,
                            },
                            lastScan,
                            taskSlots {
                                day,
                                runAt,
                                ranOn,
                                emailReport,
                            }
                        }
                    }
                }
                `,
                variables: {
                    email: global.gw.email,
                    value: global.gw.token,
                }
            }

            //let query = `{ 
            //        fetchUserAttribute(email: "${global.gw.email}", value: "${global.gw.token}") 
            //        {
            //            sites {
            //                siteGuid,
            //                main {
            //                    siteName
            //                },
            //                lastScan
            //            }
            //        }
            //    }`;

            try {
                const result = await fetchSwitch(query, output);
                return result;
            } catch (error) {
                // If it's a 401 error, re-throw it so the axios interceptor can handle it
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                // Also check for error message ending with "401"
                if (error.message && error.message.endsWith("401")) {
                    // Create a proper error object with 401 status
                    const authError = new Error(error.message);
                    authError.response = { status: 401 };
                    throw authError;
                }
                // For other errors, return false
                return false;
            }
        },
        fetchUserSite: async (output) => {
            // Check for required data
            if (!global ||
                !global.gw ||
                !global.gw.email) {
                return false;
            }
            
            // Check for siteGuid
            if (!global.gw.selectedSite || !global.gw.selectedSite.siteGuid) {
                return false;
            }
            
            // If we don't have bolts but we have token/auth, that's okay - we're already logged in
            // If we don't have either, we need to return false
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let query = {
                query: `
                        query FetchUserSiteAttribute($email: String!, $siteId: String!, $value: String!) {
                        fetchUserSiteAttribute(email: $email, siteId: $siteId, value: $value) {
                            first,
                            sites {
                                siteGuid,
                                main {
                                    siteName,
                                    bins,
                                    plus,
                                    minus,
                                    daysToCompare,
                                    emailReportTo
                                },
                                lastScan,
                                devices {
                                    ipAddress,
                                    name,
                                    modules,
                                    sections,
                                    type,
                                    model,
                                },
                                modules {
                                    id
                                    model
                                    ipAddress
                                    slot
                                    moduleType
                                    moduleUom
                                    startAt
                                    dataLength
                                    hasHumiditySensor
                                    isRo1
                                    isRo2
                                    isResistanceModule
                                    r1
                                    r2
                                    r3
                                    r4
                                    r5
                                    r6
                                    r7
                                    r8
                                    r9
                                    r10
                                    r11
                                    r12
                                    r13
                                    r14
                                    r15
                                    r16
                                    r17
                                    r18
                                    r19
                                    r20
                                    r21
                                    r22
                                    r23
                                    r24
                                    r25
                                    r26
                                    r27
                                    r28
                                    r29
                                    r30
                                    r31
                                    r32
                                    batteryLife
                                    lastUpdated
                                    alarmOn
                                    isActive
                                    humiditySensorPosition
                                    humiditySensorVoltageRange
                                    ambientTemperatureSensorPosition
                                    ambientTemperatureSensorVoltageRange
                                    deviceUniqueId
                                    hasAmbientTemperatureSensor
                                    type
                                    resistanceSensorPosition
                                },
                                bins {
                                    binId,
                                    number,
                                    name,
                                    diameter,
                                    width,
                                    length,
                                    bottleCap,
                                    degreesToNorth,
                                    peakHeight,
                                    cableLayout,
                                    height,
                                    grainWallHeight,
                                    grainHeight,
                                    positionX,
                                    positionY,
                                    positionZ,
                                    fontSize,
                                    angle,
                                    type,
                                    transparency3D,
                                    emc,
                                    fanList {
                                        fanId,
                                        fanName,
                                        fanNumber,
                                        binId,
                                        binName,
                                        fanType,
                                        fanPosition,
                                        fanSide,
                                        isOn,
                                        isOnAutomatic,
                                        isActive,
                                        alarmOn,
                                        fanIssue,
                                        lastStartTime
                                    },
                                    cableList {
                                        id,
                                        aframeId,
                                        name,
                                        number,
                                        dateRead,
                                        bottomPointX,
                                        bottomPointY,
                                        bottomPointZ,
                                        topPointX,
                                        topPointY,
                                        topPointZ,
                                        firstSensorHeight,
                                        position,
                                        anglePosition,
                                        firstBannerSensorHeight,
                                        bannerSensorSpacing,
                                        sensorSpacing,
                                        sensorCount,
                                        sensorList {
                                            id,
                                            name,
                                            binId,
                                            cableId,
                                            alternateCableId,
                                            alternateCableName,
                                            position,
                                            number,
                                            positionX,
                                            positionY,
                                            positionZ,
                                            temperature,
                                            humidity,
                                            emc,
                                            lastHumidity,
                                            type,
                                            forcedOpen,
                                            isActive,
                                            alarmOn,
                                            lastGoodTempCheck,
                                            lastGoodHumidityCheck,
                                            lastGoodEmcCheck
                                        }
                                    }
                                },
                                aframes {
                                    id,
                                    angle,
                                    binName,
                                    centerX,
                                    centerY,
                                    centerZ,
                                    height,
                                    length,
                                    name,
                                    startX,
                                    startY,
                                    startZ,
                                    type,
                                    width,
                                    binId
                                },
                                heltecSensorMappings {
                                    heltecDeviceId,
                                    sensorId,
                                },
                                layout {
                                    customerSiteLayoutId,
                                    width,
                                    length,
                                    height,
                                    rotation,
                                    x,
                                    y,
                                    z,
                                    cx,
                                    cy,
                                    cz,
                                    lx,
                                    ly,
                                    lz
                                },
                                layoutEditorProxy,
                                layoutGroups {
                                    customerSiteLayoutGroupId,
                                    customerSiteLayoutId,
                                    groupName,
                                    width,
                                    length,
                                    height,
                                    rotation,
                                    x,
                                    y,
                                    z,
                                    cx,
                                    cy,
                                    cz
                                },
                                layoutBins {
                                    customerSiteLayoutBinId,
                                    customerSiteLayoutId,
                                    customerSiteLayoutGroupId,
                                    groupOrder,
                                    binId,
                                    binName,
                                    width,
                                    length,
                                    height,
                                    x,
                                    y,
                                    z,
                                    rotation,
                                    isRound
                                },
                                layoutSides {
                                    customerSiteLayoutSideId,
                                    customerSiteLayoutId,
                                    customerSiteLayoutGroupId,
                                    customerSiteLayoutBinId,
                                    binId,
                                    binName,
                                    x1,
                                    y1,
                                    z1,
                                    x2,
                                    y2,
                                    z2,
                                    curveX,
                                    curveY,
                                    curveZ,
                                    curveRadius,
                                    isInner,
                                    isSiteRender
                                },
                                layoutCables {
                                    customerSiteLayoutCableId,
                                    customerSiteLayoutId,
                                    customerSiteLayoutGroupId,
                                    customerSiteLayoutBinId,
                                    binOrder,
                                    binId,
                                    cableId,
                                    cableName,
                                    width,
                                    length,
                                    height,
                                    x,
                                    y,
                                    z
                                },
                                layoutSensors {
                                    customerSiteLayoutSensorId,
                                    customerSiteLayoutId,
                                    customerSiteLayoutGroupId,
                                    customerSiteLayoutBinId,
                                    customerSiteLayoutCableId,
                                    cableOrder,
                                    binId,
                                    cableId,
                                    sensorId,
                                    sensorName,
                                    sensorValueString,
                                    sensorValueNumber,
                                    x,
                                    y,
                                    z
                                }
                            },
                            configuration {
                                userSiteConfigurationJsonId,
                                name,
                                siteJson,
                                dateCreated
                            }
                        }
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuidZip,
                    value: global.gw.token
                }
            }

            return await fetchSwitch(query, output);
        },
        fetchSiteLayout: async (output, siteGuid) => {
            if (!global?.gw?.email || !siteGuid) return null;
            if (!global.gw.bolts && !global.gw.token) return null;
            let siteIdForQuery = siteGuid;
            if (!global.gw.bypass) {
                const arrayBuffer = await global.compress(siteGuid, "gzip");
                siteIdForQuery = global.arrayBufferToBase64String(arrayBuffer);
            }
            const query = {
                query: `query FetchSiteLayout($email: String!, $siteId: String!, $value: String!) {
                    fetchUserSiteAttribute(email: $email, siteId: $siteId, value: $value) {
                        sites {
                            siteGuid,
                            bins {
                                binId,
                                number,
                                name,
                                cableList {
                                    id,
                                    name,
                                    number,
                                    sensorList {
                                        id,
                                        name
                                    }
                                }
                            }
                        }
                    }
                }`,
                variables: { email: global.gw.email, siteId: siteIdForQuery, value: global.gw.token }
            };
            const res = await fetchSwitch(query, output);
            if (!res || res === false) {
                return null;
            }
            const sites = res?.data?.fetchUserSiteAttribute?.sites;
            if (!Array.isArray(sites) || sites.length === 0) {
                return null;
            }
            const want = String(siteGuid).replace(/[{}]/g, '').toLowerCase();
            const match = sites.find((s) => {
                const g = s?.siteGuid ?? s?.SiteGuid;
                if (g == null) return false;
                return String(g).replace(/[{}]/g, '').toLowerCase() === want;
            });
            return match ?? null;
        },
        fetchProfile: async (output, email) => {
            // Check for email - required
            if (!global ||
                !global.gw ||
                !global.gw.email) {
                return false;
            }
            
            // If we don't have bolts but we have token/auth, that's okay - we're already logged in
            // If we don't have either, we need to return false
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }

            let query = {
                query: `
                        query FetchProfile($email: String!) {
                            fetchProfile(email: $email) {
                                id,
                                first,
                                middle,
                                last,
                                email,
                                cell
                            }
                        }
                    `,
                variables: {
                    email: email ? email : global.gw.email,
                }
            }

            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                // If it's a 401 error, re-throw it so the axios interceptor can handle it
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                // Also check for error message ending with "401"
                if (error.message && error.message.endsWith("401")) {
                    // Create a proper error object with 401 status
                    const authError = new Error(error.message);
                    authError.response = { status: 401 };
                    throw authError;
                }
                // For other errors, return false
                return false;
            }
        },
        fetchUserSiteHistoryWithDate: async (output, start, end, timeOfDay) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }
            // If we don't have bolts but we have token/auth, that's okay - we're already logged in
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let query = {};

            if (output === "direct") {
                query = {
                    query: `
                            query UserHistory($email: String!, $siteId: ID!, $startDate: DateTime!, $endDate: DateTime!, $time: String) {
                                getUserHistoryWithDateAndTime(email: $email, siteId: $siteId, startDate: $startDate, endDate: $endDate, time: $time) {
                                    dateCableReadHistories {
                                        dateCableRead,
                                        sensorHistories {
                                            sensorId,
                                            sensorName,
                                            temperature,
                                            lastTemperature,
                                        }
                                    }
                                }
                            }
                        `,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                        startDate: start,
                        endDate: end,
                        time: timeOfDay || "04:00:00"
                    }
                };
            }
            else {
                query = {
                    query: `
                    query FetchUserSiteHistoryWithDate($email: String!, $siteId: ID!, $startDate: DateTime!, $endDate: DateTime!, $time: String) {
                        getUserHistoryWithDateAndTime(email: $email, siteId: $siteId, startDate: $startDate, endDate: $endDate, time: $time) {
                            dateCableReadHistories {
                                dateCableRead,
                                sensorHistories {
                                    sensorId,
                                    sensorName,
                                    temperature,
                                    lastTemperature,
                                }
                            }
                        }
                    }
                `,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                        startDate: start,
                        endDate: end,
                        time: timeOfDay || "04:00:00"
                    }
                };
            }

            return await fetchSwitch(query, output, undefined, 120000);
        },
        fetchUserSiteAllHistoryDatesWithDays: async (output, days) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let query = {};
            query = {
                query: `
                    query FetchUserSiteAllHistoryDatesWithDays($email: String!, $siteId: ID!, $days: Int!) {
                        fetchUserSiteAllHistoryDatesWithDays(email: $email, siteId: $siteId, days: $days)
                    }
            `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    days: days,
                }
            };


            //let query = {};

            //if (output === "direct") {
            //    query = {
            //        query: `
            //                query FetchUserSiteAllHistoryDatesWithDays($email: String!, $siteId: ID!, $days: Int!) {
            //                    fetchUserSiteAllHistoryDatesWithDays(email: $email, siteId: $siteId, days: $days)
            //                }
            //            `,
            //        variables: {
            //            email: global.gw.email,
            //            siteId: global.gw.selectedSite.siteGuid,
            //            days: days,
            //        }
            //    };
            //}
            //else {
            //    query = {
            //        query: `
            //        query FetchUserSiteAllHistoryDatesWithDays($email: String!, $siteId: ID!, $days: Int!) {
            //            fetchUserSiteAllHistoryDatesWithDays(email: $email, siteId: $siteId, days: $days)
            //        }
            //    `,
            //        variables: {
            //            email: global.gw.email,
            //            siteId: global.gw.selectedSite.siteGuid,
            //            days: days,
            //        }
            //    };
            //}

            return await fetchSwitch(query, output);
        },
        fetchUserSiteAllHistoryDatesWithDateRange: async (output, dateFrom, dateTo) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            const query = {
                query: `
                    query FetchUserSiteAllHistoryDatesWithDateRange($email: String!, $siteId: ID!, $dateFrom: DateTime!, $dateTo: DateTime!) {
                        fetchUserSiteAllHistoryDatesWithDateRange(email: $email, siteId: $siteId, dateFrom: $dateFrom, dateTo: $dateTo)
                    }
                `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    dateFrom: dateFrom instanceof Date ? dateFrom.toISOString() : dateFrom,
                    dateTo: dateTo instanceof Date ? dateTo.toISOString() : dateTo,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchTemperatureHistoryReport: async (output, dates, daysToCompare, plus, minus, isAm) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {};
            query = {
                query: `
                query FetchTemperatureHistoryReport($email: String!, $siteId: String!, $dates: [DateTime!], $daysToCompare: Int, $plus: Int, $minus: Int, $isAm: Boolean) {
                    fetchTemperatureHistoryReport(email: $email, siteId: $siteId, dates: $dates, daysToCompare: $daysToCompare, plus: $plus, minus: $minus, isAm: $isAm) {
                        value
                    }
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    dates: dates,
                    daysToCompare: daysToCompare,
                    plus: plus,
                    minus: minus,
                    isAm: isAm,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchReportTemperatureComparisonData: async (output, ...args) => {
            if (!global ||
                !global.gw ||
                !global.gw.email) {
                return false;
            }
            // encrypted / base64 / compressed require gw.bolts for RSA; direct uses Bearer token only
            const needsBoltChannel =
                output === "encrypted" ||
                output === "base64" ||
                output === "compressed";
            if (needsBoltChannel && !global.gw.bolts) {
                return false;
            }
            if (!needsBoltChannel && !global.gw.token) {
                return false;
            }

            const siteGuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            let siteId = global.gw.selectedSite?.siteGuid;
            if (args.length > 0 && typeof args[0] === 'string' && siteGuidPattern.test(args[0])) {
                siteId = args.shift();
            }
            if (!siteId) {
                return false;
            }

            let daysToCompare;
            let targetDate;
            let targetTime;
            let timeOffset;
            let searchWindow;
            let plus;
            let minus;
            let rawTitle;
            let newTitle;
            let binName;
            let cableName;

            if (args.length > 0 && Array.isArray(args[0])) {
                const [dates, dtc, p, m, bn, cn] = args;
                const anchor = dates?.[0] ?? null;
                targetDate = anchor;
                targetTime = anchor;
                daysToCompare = dtc;
                plus = p;
                minus = m;
                timeOffset = 5;
                searchWindow = 10;
                rawTitle = undefined;
                newTitle = undefined;
                binName = bn;
                cableName = cn;
            } else {
                [
                    daysToCompare,
                    targetDate,
                    targetTime,
                    timeOffset = 5,
                    searchWindow = 10,
                    plus,
                    minus,
                    rawTitle,
                    newTitle,
                    binName,
                    cableName,
                ] = args;
            }

            // Do not use toISOString() for targetDate/targetTime: it converts local picks to UTC and breaks
            // @targetDate (date) / @targetTime (time) on the server. Send wall-clock components without Z.
            const pad2 = (n) => String(n).padStart(2, '0');
            const pad3 = (n) => String(n).padStart(3, '0');
            const toGraphQlLocalDate = (v) => {
                if (v == null) return null;
                const d = v instanceof Date ? v : new Date(v);
                if (Number.isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T00:00:00`;
            };
            const toGraphQlLocalTimeOfDay = (v) => {
                if (v == null) return null;
                const d = v instanceof Date ? v : new Date(v);
                if (Number.isNaN(d.getTime())) return null;
                const ms = d.getMilliseconds();
                const frac = ms ? `.${pad3(ms)}` : '';
                return `2000-01-01T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}${frac}`;
            };

            let query = {};
            query = {
                query: `
                query FetchReportTemperatureComparisonData(
                    $email: String!,
                    $siteId: String!,
                    $daysToCompare: Int,
                    $targetDate: DateTime,
                    $targetTime: DateTime,
                    $timeOffset: Float,
                    $searchWindow: Int,
                    $plus: Int,
                    $minus: Int,
                    $rawTitle: String,
                    $newTitle: String,
                    $binName: String,
                    $cableName: String,
                ) {
                    fetchReportTemperatureComparisonData(
                        email: $email,
                        siteId: $siteId,
                        daysToCompare: $daysToCompare,
                        targetDate: $targetDate,
                        targetTime: $targetTime,
                        timeOffset: $timeOffset,
                        searchWindow: $searchWindow,
                        plus: $plus,
                        minus: $minus,
                        rawTitle: $rawTitle,
                        newTitle: $newTitle,
                        binName: $binName,
                        cableName: $cableName,
                    ) {
                        value
                    }
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId,
                    daysToCompare: daysToCompare ?? null,
                    targetDate: toGraphQlLocalDate(targetDate),
                    targetTime: toGraphQlLocalTimeOfDay(targetTime),
                    timeOffset: timeOffset ?? 5,
                    searchWindow: searchWindow ?? 10,
                    plus: plus ?? null,
                    minus: minus ?? null,
                    rawTitle: rawTitle ?? null,
                    newTitle: newTitle ?? null,
                    binName: typeof binName === 'string' && binName.trim() ? binName.trim() : null,
                    cableName: typeof cableName === 'string' && cableName.trim() ? cableName.trim() : null,
                }
            };

            return await fetchSwitch(query, output);
        },
        /**
         * Email the site comparison PDF (same filters as fetchReportTemperatureComparisonData).
         * @param {string} reportToEmails Comma/semicolon-separated addresses (see Main.emailReportTo).
         * @param {...*} args Same as fetchReportTemperatureComparisonData after siteId.
         */
        fetchEmailReportTemperatureComparisonData: async (output, reportToEmails, ...args) => {
            if (!global ||
                !global.gw ||
                !global.gw.email) {
                return false;
            }
            const needsBoltChannel =
                output === "encrypted" ||
                output === "base64" ||
                output === "compressed";
            if (needsBoltChannel && !global.gw.bolts) {
                return false;
            }
            if (!needsBoltChannel && !global.gw.token) {
                return false;
            }

            const siteGuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            let siteId = global.gw.selectedSite?.siteGuid;
            if (args.length > 0 && typeof args[0] === 'string' && siteGuidPattern.test(args[0])) {
                siteId = args.shift();
            }
            if (!siteId) {
                return false;
            }

            let daysToCompare;
            let targetDate;
            let targetTime;
            let timeOffset;
            let searchWindow;
            let plus;
            let minus;
            let rawTitle;
            let newTitle;
            let binName;
            let cableName;

            if (args.length > 0 && Array.isArray(args[0])) {
                const [dates, dtc, p, m, bn, cn] = args;
                const anchor = dates?.[0] ?? null;
                targetDate = anchor;
                targetTime = anchor;
                daysToCompare = dtc;
                plus = p;
                minus = m;
                timeOffset = 5;
                searchWindow = 10;
                rawTitle = undefined;
                newTitle = undefined;
                binName = bn;
                cableName = cn;
            } else {
                [
                    daysToCompare,
                    targetDate,
                    targetTime,
                    timeOffset = 5,
                    searchWindow = 10,
                    plus,
                    minus,
                    rawTitle,
                    newTitle,
                    binName,
                    cableName,
                ] = args;
            }

            const pad2 = (n) => String(n).padStart(2, '0');
            const pad3 = (n) => String(n).padStart(3, '0');
            const toGraphQlLocalDate = (v) => {
                if (v == null) return null;
                const d = v instanceof Date ? v : new Date(v);
                if (Number.isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T00:00:00`;
            };
            const toGraphQlLocalTimeOfDay = (v) => {
                if (v == null) return null;
                const d = v instanceof Date ? v : new Date(v);
                if (Number.isNaN(d.getTime())) return null;
                const ms = d.getMilliseconds();
                const frac = ms ? `.${pad3(ms)}` : '';
                return `2000-01-01T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}${frac}`;
            };

            const rte =
                typeof reportToEmails === 'string' && reportToEmails.trim()
                    ? reportToEmails.trim()
                    : null;

            let query = {};
            query = {
                query: `
                query FetchEmailReportTemperatureComparisonData(
                    $email: String!,
                    $siteId: String!,
                    $reportToEmails: String!,
                    $daysToCompare: Int,
                    $targetDate: DateTime,
                    $targetTime: DateTime,
                    $timeOffset: Float,
                    $searchWindow: Int,
                    $plus: Int,
                    $minus: Int,
                    $rawTitle: String,
                    $newTitle: String,
                    $binName: String,
                    $cableName: String,
                ) {
                    fetchEmailReportTemperatureComparisonData(
                        email: $email,
                        siteId: $siteId,
                        reportToEmails: $reportToEmails,
                        daysToCompare: $daysToCompare,
                        targetDate: $targetDate,
                        targetTime: $targetTime,
                        timeOffset: $timeOffset,
                        searchWindow: $searchWindow,
                        plus: $plus,
                        minus: $minus,
                        rawTitle: $rawTitle,
                        newTitle: $newTitle,
                        binName: $binName,
                        cableName: $cableName,
                    )
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId,
                    reportToEmails: rte ?? '',
                    daysToCompare: daysToCompare ?? null,
                    targetDate: toGraphQlLocalDate(targetDate),
                    targetTime: toGraphQlLocalTimeOfDay(targetTime),
                    timeOffset: timeOffset ?? 5,
                    searchWindow: searchWindow ?? 10,
                    plus: plus ?? null,
                    minus: minus ?? null,
                    rawTitle: rawTitle ?? null,
                    newTitle: newTitle ?? null,
                    binName: typeof binName === 'string' && binName.trim() ? binName.trim() : null,
                    cableName: typeof cableName === 'string' && cableName.trim() ? cableName.trim() : null,
                }
            };

            return await fetchSwitch(query, output);
        },
        /**
         * BTS Main (daysToCompare, plus, minus) + Task time for forDate's weekday.
         * With bolts, use output 'compressed' and pass gzip-base64 siteId (same as fetchUserSiteAttribute).
         * With token only, use 'direct' and plain siteGuid.
         */
        fetchSiteComparisonFormDefaults: async (output, siteGuid, forDate, includeClosestToNow = true) => {
            if (!global?.gw?.email || !siteGuid) {
                return false;
            }
            const needsBoltChannel =
                output === 'encrypted' ||
                output === 'base64' ||
                output === 'compressed';
            if (needsBoltChannel && !global.gw.bolts) {
                return false;
            }
            if (!needsBoltChannel && !global.gw.token) {
                return false;
            }
            const pad2 = (n) => String(n).padStart(2, '0');
            const toGraphQlLocalDate = (v) => {
                if (v == null) return null;
                const d = v instanceof Date ? v : new Date(v);
                if (Number.isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T00:00:00`;
            };
            let siteIdForQuery = siteGuid;
            if (needsBoltChannel) {
                if (global.gw.bypass) {
                    siteIdForQuery = siteGuid;
                } else {
                    const norm = (g) => String(g == null ? '' : g).replace(/[{}]/g, '').toLowerCase();
                    const want = norm(siteGuid);
                    const cur = norm(global.gw.selectedSite?.siteGuid);
                    if (want && want === cur && global.gw.selectedSite?.siteGuidZip) {
                        siteIdForQuery = global.gw.selectedSite.siteGuidZip;
                    } else {
                        const arrayBuffer = await global.compress(siteGuid, 'gzip');
                        siteIdForQuery = global.arrayBufferToBase64String(arrayBuffer);
                    }
                }
            }
            const query = {
                query: `
                    query FetchSiteComparisonFormDefaults($email: String!, $siteId: String!, $forDate: DateTime) {
                        fetchSiteComparisonFormDefaults(email: $email, siteId: $siteId, forDate: $forDate) {
                            taskTimeHms${includeClosestToNow ? '\n                            taskTimeHmsClosestToNow' : ''}
                            daysToCompare
                            plus
                            minus
                        }
                    }
                `,
                variables: {
                    email: global.gw.email,
                    siteId: siteIdForQuery,
                    forDate: toGraphQlLocalDate(forDate),
                },
            };
            return await fetchSwitch(query, output);
        },
        fetchEmailTemperatureHistoryReport: async (output, dates, daysToCompare, plus, minus, isAm) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {};
            query = {
                query: `
                query FetchEmailTemperatureHistoryReport($email: String!, $siteId: String!, $dates: [DateTime!], $daysToCompare: Int, $plus: Int, $minus: Int, $isAm: Boolean) {
                    fetchEmailTemperatureHistoryReport(email: $email, siteId: $siteId, dates: $dates, daysToCompare: $daysToCompare, plus: $plus, minus: $minus, isAm: $isAm)
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    dates: dates,
                    daysToCompare: daysToCompare,
                    plus: plus,
                    minus: minus,
                    isAm: isAm,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSearchTemperatureHistory: async (output, binId, binName, cableId, cableName, sensorId, sensorName, dateFrom, dateTo, hourFrom, hourTo, isOneReadingPerDay) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }

            let query = {};
            query = {
                query: `
                query FetchSearchTemperatureHistory($email: String!, $siteId: String!, $binId: Int, $binName: String, $cableId: Int, $cableName: String, $sensorId: Int, $sensorName: String, $dateFrom: DateTime, $dateTo: DateTime, $hourFrom: Int, $hourTo: Int, $isOneReadingPerDay: Boolean) {
                    fetchSearchTemperatureHistory(email: $email, siteId: $siteId, binId: $binId, binName: $binName, cableId: $cableId, cableName: $cableName, sensorId: $sensorId, sensorName: $sensorName, dateFrom: $dateFrom, dateTo: $dateTo, hourFrom: $hourFrom, hourTo: $hourTo, isOneReadingPerDay: $isOneReadingPerDay) {
                        binId,
                        binName,
                        cableId,
                        cableName,
                        sensorId,
                        sensorName,
                        position,
                        dateCableRead,
                        temperature
                    }
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    binId: binId,
                    binName: binName,
                    cableId: cableId,
                    cableName: cableName,
                    sensorId: sensorId,
                    sensorName: sensorName,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    hourFrom: hourFrom,
                    hourTo: hourTo,
                    isOneReadingPerDay: isOneReadingPerDay,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchGetSiteGrainLevels: async (output, binId, binName, cableId, cableName, sensorId, sensorName, dateFrom, dateTo, hourFrom, hourTo, isOneReadingPerDay, resolution) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {};
            query = {
                query: `
                query FetchGetSiteGrainLevels($email: String!, $siteId: String!, $binId: Int, $binName: String, $cableId: Int, $cableName: String, $sensorId: Int, $sensorName: String, $dateFrom: DateTime, $dateTo: DateTime, $hourFrom: Int, $hourTo: Int, $isOneReadingPerDay: Boolean, $resolution Int) {
                    fetchGetSiteGrainLevels(email: $email, siteId: $siteId, binId: $binId, binName: $binName, cableId: $cableId, cableName: $cableName, sensorId: $sensorId, sensorName: $sensorName, dateFrom: $dateFrom, dateTo: $dateTo, hourFrom: $hourFrom, hourTo: $hourTo, isOneReadingPerDay: $isOneReadingPerDay, resolution: $resolution) {
                        binId,
                        binName,
                        cableId,
                        cableName,
                        sensorId,
                        sensorName,
                        position,
                        dateCableRead,
                        temperature
                    }
                }
            `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    binId: binId,
                    binName: binName,
                    cableId: cableId,
                    cableName: cableName,
                    sensorId: sensorId,
                    sensorName: sensorName,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    hourFrom: hourFrom,
                    hourTo: hourTo,
                    isOneReadingPerDay: isOneReadingPerDay,
                    resolution: resolution,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteWeatherStationReadings: async (output, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);
 
            let query = {
                    query: `
                            query GetSiteWeatherStationReadings($email: String!, $siteId: String!, $json: String!) {
                                getSiteWeatherStationReadings(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                        json: jsonCompressed,
                    }
                };

            return await fetchSwitch(query, output);
        },
        // Mirrors fetchSiteWeatherStationReadings: server `getSiteBinLevels` SP picks BinLevel (latest)
        // when json has no dateFrom/dateTo, BinLevelHistory when both are present. Caller passes
        // { binId? , dateFrom? , dateTo? } -- omit binId for "all bins", omit dates for "latest snapshot".
        fetchSiteBinLevels: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !effectiveSiteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = effectiveSiteGuid;
            }
            else {
                const arrayBuffer = await global.compress(effectiveSiteGuid, "gzip");
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json ?? {}), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                        query GetSiteBinLevels($email: String!, $siteId: String!, $json: String!) {
                            getSiteBinLevels(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        // Single-call read for the Site Inventory modal: server returns a base64-gzipped JSON
        // envelope with { bins, grains, binLevels, binDimensions, layoutBins, lastBinLevelHistoryByBin } from BTS +
        // Temputech layout (layoutBins keyed by BinId for dimension overrides / Stice).
        fetchSiteInventory: async (output, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !effectiveSiteGuid) {
                return false;
            }

            let query = {
                query: `
                        query GetSiteInventory($email: String!, $siteId: String!) {
                            getSiteInventory(email: $email, siteId: $siteId)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                }
            };

            return await fetchSwitch(query, output);
        },
        // Persists grain inventory snapshot: `{ binLevels: [...], binLevelHistories?: [...] }`.
        // Server copies current BinLevel to BinLevelHistory, TRUNCATEs BinLevel, inserts new rows,
        // and appends each new snapshot to BinLevelHistory as well.
        fetchSyncBinLevel: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !effectiveSiteGuid) {
                return false;
            }

            const payload = JSON.stringify(json ?? {});
            let query = {
                query: `
                        mutation SyncBinLevel($email: String!, $siteId: ID!, $json: String) {
                            syncBinLevel(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    json: payload,
                }
            };

            return await fetchSwitch(query, output);
        },
        // Persists Site Inventory bin geometry to dbo.BinDimension on the site BTS DB.
        // Payload: { binDimensions: [{ binId, shapeKind, diameter, height, peakHeight, length, width, peakLength }] }.
        fetchSyncSiteBinDimensions: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global || !global.gw || !global.gw.email || !effectiveSiteGuid) {
                return false;
            }

            const payload = JSON.stringify(json ?? {});
            let query = {
                query: `
                        mutation SyncSiteBinDimensions($email: String!, $siteId: ID!, $json: String) {
                            syncSiteBinDimensions(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    json: payload,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchBinGrades: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !effectiveSiteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = effectiveSiteGuid;
            }
            else {
                const arrayBuffer = await global.compress(effectiveSiteGuid, "gzip");
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                        query GetBinGrades($email: String!, $siteId: String!, $json: String!) {
                            getBinGrades(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchCableGrades: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !effectiveSiteGuid) {
                return false;
            }

            const siteForZip = global.gw.selectedSite && global.gw.selectedSite.siteGuid === effectiveSiteGuid
                ? global.gw.selectedSite
                : { siteGuid: effectiveSiteGuid };
            if (global.gw.bypass) {
                siteForZip.siteGuidZip = effectiveSiteGuid;
            }
            else {
                const arrayBuffer = await global.compress(effectiveSiteGuid, "gzip");
                siteForZip.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                        query GetCableGrades($email: String!, $siteId: String!, $json: String!) {
                            getCableGrades(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteGrade: async (output, json, siteId) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts) {
                return false;
            }

            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!effectiveSiteId) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = effectiveSiteId;
            }
            else {
                const arrayBuffer = await global.compress(effectiveSiteId, "gzip");
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonPayload = json ?? { date: null };
            let jsonBuffer = await global.compress(JSON.stringify(jsonPayload), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                        query GetSiteGrade($email: String!, $siteId: String!, $json: String!) {
                            getSiteGrade(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteGradeDates: async (output, siteId) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !global.gw.bolts || !effectiveSiteId) return false;
            if (global.gw.bypass) {
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = effectiveSiteId;
            } else {
                const arrayBuffer = await global.compress(effectiveSiteId, "gzip");
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }
            const query = {
                query: `query GetSiteGradeDates($email: String!, $siteId: String!) { getSiteGradeDates(email: $email, siteId: $siteId) }`,
                variables: { email: global.gw.email, siteId: effectiveSiteId },
            };
            return await fetchSwitch(query, output);
        },
        fetchSensorGrades: async (output, json, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !global.gw.bolts || !effectiveSiteGuid) return false;
            const siteForZip = global.gw.selectedSite?.siteGuid === effectiveSiteGuid ? global.gw.selectedSite : { siteGuid: effectiveSiteGuid };
            if (global.gw.bypass) siteForZip.siteGuidZip = effectiveSiteGuid;
            else {
                const arrayBuffer = await global.compress(effectiveSiteGuid, "gzip");
                siteForZip.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }
            const jsonPayload = json ?? { date: null };
            const jsonCompressed = global.arrayBufferToBase64String(await global.compress(JSON.stringify(jsonPayload), "gzip"));
            const query = {
                query: `query GetSensorGrades($email: String!, $siteId: String!, $json: String!) { getSensorGrades(email: $email, siteId: $siteId, json: $json) }`,
                variables: { email: global.gw.email, siteId: effectiveSiteGuid, json: jsonCompressed },
            };
            return await fetchSwitch(query, output);
        },
        fetchUserCustomerSiteSavedView: async (output, siteId, viewType, binId) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) return null;
            if (!global.gw.bolts && !global.gw.token) return null;
            const query = {
                query: `query GetUserCustomerSiteSavedView($email: String!, $siteId: String!, $viewType: String!, $binId: Int!) {
                    getUserCustomerSiteSavedView(email: $email, siteId: $siteId, viewType: $viewType, binId: $binId)
                }`,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                    viewType: viewType || 'Site',
                    binId: binId ?? 0
                }
            };
            const res = await fetchSwitch(query, output);
            const raw = res?.data?.getUserCustomerSiteSavedView;
            if (!raw || typeof raw !== 'string') return null;
            try {
                const arrayBuffer = global.base64StringToArrayBuffer(raw);
                const decompressed = await global.decompress(arrayBuffer, "gzip");
                return JSON.parse(decompressed);
            } catch {
                return null;
            }
        },
        fetchSiteDirectScanStatus: async (output, siteId) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) return null;
            if (!global.gw.bolts && !global.gw.token) return null;
            const query = {
                query: `query CheckSiteDirectScanStatus($email: String!, $siteId: String!) {
                    getCheckSiteDirectScanStatus(email: $email, siteId: $siteId)
                }`,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                }
            };
            const res = await fetchSwitch(query, output);
            const raw = res?.data?.getCheckSiteDirectScanStatus;
            if (!raw || typeof raw !== 'string') return null;
            try {
                const arrayBuffer = global.base64StringToArrayBuffer(raw);
                const decompressed = await global.decompress(arrayBuffer, "gzip");
                return JSON.parse(decompressed);
            } catch {
                return null;
            }
        },
        saveUserCustomerSiteSavedView: async (output, siteId, viewType, binId, viewData) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !viewData) return false;
            const payload = { viewType: viewType || 'Site', binId: binId ?? 0, ...viewData };
            const jsonBuffer = await global.compress(JSON.stringify(payload), "gzip");
            const jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);
            const query = {
                query: `mutation SaveUserCustomerSiteSavedView($email: String!, $siteId: String!, $json: String!) {
                    saveUserCustomerSiteSavedView(email: $email, siteId: $siteId, json: $json)
                }`,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                    json: jsonCompressed
                }
            };
            const res = await fetchSwitch(query, output);
            return res?.data?.saveUserCustomerSiteSavedView ?? false;
        },
        /**
         * Persist a CustomerSiteLayout draft built in the layout-import UI.
         * Wire matches saveUserCustomerSiteSavedView: gzip-compress the draft JSON, base64,
         * and post over the existing fetchSwitch transport (Bearer JWT or RSA fallback).
         *
         * `draft` shape mirrors the GraphQL `fetchUserSite` layout payload (camelCase):
         *   { bounds: { ... }, groups: [ { ..., bins: [ { ..., sides?: [ ... ] } ] } ] }
         * Returns `true` on success.
         */
        saveCustomerSiteLayout: async (output, siteId, draft) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !draft) return false;
            const jsonBuffer = await global.compress(JSON.stringify(draft), "gzip");
            const jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);
            const query = {
                query: `mutation SaveCustomerSiteLayout($email: String!, $siteId: String!, $json: String!) {
                    saveCustomerSiteLayout(email: $email, siteId: $siteId, json: $json)
                }`,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                    json: jsonCompressed
                }
            };
            const res = await fetchSwitch(query, output);
            return res?.data?.saveCustomerSiteLayout ?? false;
        },
        fetchSiteLayoutEditorDraft: async (output, siteId) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) return null;
            const query = {
                query: `query FetchSiteLayoutEditorDraft($email: String!, $siteId: String!) {
                    fetchSiteLayoutEditorDraft(email: $email, siteId: $siteId)
                }`,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteId,
                },
            };
            const res = await fetchSwitch(query, output);
            if (!res || res === false || res.errors?.length) return null;
            const raw = res?.data?.fetchSiteLayoutEditorDraft;
            if (!raw || typeof raw !== "string") return null;
            try {
                return JSON.parse(raw);
            } catch {
                return null;
            }
        },
        saveUserCustomerSiteSavedViewForAllUsers: async (output, siteId, viewType, binId, viewData) => {
            const effectiveSiteId = siteId || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !viewData) return false;
            const payload = { viewType: viewType || 'Site', binId: binId ?? 0, ...viewData };
            const jsonBuffer = await global.compress(JSON.stringify(payload), "gzip");
            const jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);
            const emailNorm = (global.gw.email || '').trim().toLowerCase();
            const query = {
                query: `mutation SaveUserCustomerSiteSavedViewForAllUsers($email: String!, $siteId: String!, $json: String!) {
                    saveUserCustomerSiteSavedViewForAllUsers(email: $email, siteId: $siteId, json: $json)
                }`,
                variables: {
                    email: emailNorm,
                    siteId: effectiveSiteId,
                    json: jsonCompressed
                }
            };
            const res = await fetchSwitch(query, output);
            return res?.data?.saveUserCustomerSiteSavedViewForAllUsers ?? false;
        },
        fetchSiteWeatherStationDevices: async (output, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !effectiveSiteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = effectiveSiteGuid;
            }
            else {
                const arrayBuffer = await global.compress(effectiveSiteGuid, "gzip");
                global.gw.selectedSite = global.gw.selectedSite || {};
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let query = {
                query: `
                            query GetSiteWeatherStationDevices($email: String!, $siteId: String!) {
                                getSiteWeatherStationDevices(email: $email, siteId: $siteId)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchWeatherStationReadingSettings: async (output, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            query GetWeatherStationReadingSettings($email: String!, $siteId: String!, $json: String!) {
                                getWeatherStationReadingSettings(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchUpsertWeatherStationReadingSetting: async (output, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            mutation UpsertWeatherStationReadingSetting($email: String!, $siteId: String!, $json: String!) {
                                upsertWeatherStationReadingSetting(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteWeatherStationTables: async (output) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let query = {
                query: `
                            query GetSiteWeatherStationTables($email: String!, $siteId: String!) {
                                getSiteWeatherStationTables(email: $email, siteId: $siteId)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteCurrentWeatherStationReadings: async (output, siteGuid) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {
                query: `
                            query GetSiteCurrentWeatherStationReadings($email: String!, $siteId: String!) {
                                getSiteCurrentWeatherStationReadings(email: $email, siteId: $siteId)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: siteGuid,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchAllSitesCurrentWeatherStationReadings: async (output, signal) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts) {
                return false;
            }

            let query = {
                query: `
                            query GetAllSitesCurrentWeatherStationReadings($email: String!) {
                                getAllSitesCurrentWeatherStationReadings(email: $email)
                            }
                        `,
                variables: {
                    email: global.gw.email
                }
            };

            try {
                return await fetchSwitch(query, output, signal);
            } catch (error) {
                // If it's a 401 error, re-throw it so the axios interceptor can handle it
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                // Also check for error message containing "401"
                if (error.message && (error.message.includes("401") || error.message.includes("Unauthorized"))) {
                    // Create a proper error object with 401 status
                    const authError = new Error(error.message);
                    authError.response = { status: 401 };
                    throw authError;
                }
                // For other errors, return false
                return false;
            }
        },
        fetchAllSitesIssues: async (output) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts) {
                return null;
            }

            let query = {
                query: `
                    query GetAllSitesIssues($email: String!) {
                        getAllSitesIssues(email: $email)
                    }
                `,
                variables: {
                    email: global.gw.email
                }
            };

            try {
                const response = await fetchSwitch(query, output);
                if (response && response.data && response.data.getAllSitesIssues) {
                    const data = response.data.getAllSitesIssues;
                    if (typeof data === 'string') {
                        return data ? JSON.parse(data) : [];
                    }
                    return Array.isArray(data) ? data : [];
                }
                return [];
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return [];
            }
        },
        fetchAllSiteIssuesForAdmin: async (output) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts) {
                return [];
            }

            let query = {
                query: `
                    query GetAllSiteIssuesForAdmin($email: String!) {
                        getAllSiteIssuesForAdmin(email: $email)
                    }
                `,
                variables: {
                    email: global.gw.email
                }
            };

            try {
                const response = await fetchSwitch(query, output);
                if (response && response.data && response.data.getAllSiteIssuesForAdmin) {
                    const data = response.data.getAllSiteIssuesForAdmin;
                    if (typeof data === 'string') {
                        return data ? JSON.parse(data) : [];
                    }
                    return Array.isArray(data) ? data : [];
                }
                return [];
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return [];
            }
        },
        updateSiteIssueNotes: async (siteIssueId, notes) => {
            if (!global?.gw?.email || !global?.gw?.bolts) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation UpdateSiteIssueNotes($email: String!, $siteIssueId: String!, $notes: String) {
                        updateSiteIssueNotes(email: $email, siteIssueId: $siteIssueId, notes: $notes)
                    }`,
                    variables: { email: global.gw.email, siteIssueId: String(siteIssueId), notes: notes || null }
                }, "direct");
                return response?.data?.updateSiteIssueNotes ?? false;
            } catch { return false; }
        },
        resolveSiteIssue: async (siteIssueId) => {
            if (!global?.gw?.email || !global?.gw?.bolts) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation ResolveSiteIssue($email: String!, $siteIssueId: String!) {
                        resolveSiteIssue(email: $email, siteIssueId: $siteIssueId)
                    }`,
                    variables: { email: global.gw.email, siteIssueId: String(siteIssueId) }
                }, "direct");
                return response?.data?.resolveSiteIssue ?? false;
            } catch { return false; }
        },
        reopenSiteIssue: async (siteIssueId) => {
            if (!global?.gw?.email || !global?.gw?.bolts) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation ReopenSiteIssue($email: String!, $siteIssueId: String!) {
                        reopenSiteIssue(email: $email, siteIssueId: $siteIssueId)
                    }`,
                    variables: { email: global.gw.email, siteIssueId: String(siteIssueId) }
                }, "direct");
                return response?.data?.reopenSiteIssue ?? false;
            } catch { return false; }
        },
        addSiteIssue: async (siteId, issue, notes) => {
            if (!global?.gw?.email || !global?.gw?.bolts) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation AddSiteIssue($email: String!, $siteId: String!, $issue: String!, $notes: String) {
                        addSiteIssue(email: $email, siteId: $siteId, issue: $issue, notes: $notes)
                    }`,
                    variables: { email: global.gw.email, siteId: String(siteId), issue: (issue || '').trim(), notes: (notes || '').trim() || null }
                }, "direct");
                return response?.data?.addSiteIssue ?? false;
            } catch { return false; }
        },
        fetchUploadWeatherStation: async (output, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            mutation UploadWeatherStation($email: String!, $siteId: String!, $json: String!) {
                                uploadWeatherStation(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteHeltecReadings: async (output) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {
                query: `
                            query GetSiteHeltecReadings($email: String!, $siteId: String!) {
                                getSiteHeltecReadings(email: $email, siteId: $siteId)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                }
            };

            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                // If it's a 401 error, re-throw it so the axios interceptor can handle it
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                // Also check for error message containing "401"
                if (error.message && (error.message.includes("401") || error.message.includes("Unauthorized"))) {
                    // Create a proper error object with 401 status
                    const authError = new Error(error.message);
                    authError.response = { status: 401 };
                    throw authError;
                }
                // For other errors, return false
                return false;
            }
        },
        fetchSiteHmsData: async (output) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let query = {
                query: `
                            query GetSiteHmsData($email: String!, $siteId: String!) {
                                getSiteHmsData(email: $email, siteId: $siteId)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                }
            };

            return await fetchSwitch(query, output);
        },
        resetMultifaceDevice: async (output, deviceName) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !global.gw.selectedSite ||
                !global.gw.selectedSite.siteGuid) {
                return false;
            }

            let jsonData = JSON.stringify({ deviceName: deviceName });
            let jsonBuffer = await global.compress(jsonData, "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            mutation ResetMultifaceDevice($email: String!, $siteId: String!, $json: String!) {
                                resetMultifaceDevice(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        fetchSiteWeatherStationHistory: async (output, siteId, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !siteId) {
                return false;
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            query GetSiteWeatherStationHistory($email: String!, $siteId: String!, $json: String!) {
                                getSiteWeatherStationHistory(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: siteId,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        resetMultifaceDevice: async (output, siteId, json) => {
            if (!global ||
                !global.gw ||
                !global.gw.email ||
                !global.gw.bolts ||
                !siteId) {
                return false;
            }

            if (global.gw.bypass) {
                global.gw.selectedSite.siteGuidZip = global.gw.selectedSite.siteGuid;
            }
            else {
                const arrayBuffer = await global.compress(global.gw.selectedSite.siteGuid, "gzip");
                global.gw.selectedSite.siteGuidZip = global.arrayBufferToBase64String(arrayBuffer);
            }

            let jsonBuffer = await global.compress(JSON.stringify(json), "gzip");
            let jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);

            let query = {
                query: `
                            query ResetMultifaceDevice($email: String!, $siteId: String!, $json: String!) {
                                resetMultifaceDevice(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: siteId,
                    json: jsonCompressed,
                }
            };

            return await fetchSwitch(query, output);
        },
        /** Direct GraphQL: last scan status for current site (Scan.js polling). */
        fetchLastScan: async (output) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }
            const query = {
                query: `
                        query UserScan($email: String!, $siteId: ID!) {
                            getLastScan(email: $email, siteId: $siteId) {
                                id,
                                dateStarted,
                                scanCable,
                                finishedCables,
                                isComplete,
                                isCanceled,
                                jsonCommand
                            }
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                }
            };
            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                if (error.message && error.message.endsWith("401")) {
                    const authError = new Error(error.message);
                    authError.response = { status: 401 };
                    throw authError;
                }
                return false;
            }
        },
        /** Direct GraphQL: cancel / update scan (Scan.js). */
        fetchUpdateScan: async (output, jsonPayloadString) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }
            const query = {
                query: `
                        mutation UpdateScan($email: String!, $siteId: ID!, $json: String!) {
                            updateScan(email: $email, siteId: $siteId, json: $json)
                        }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: jsonPayloadString,
                }
            };
            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return false;
            }
        },
        /** Direct GraphQL: live BTS Sensor snapshot for scan window (LastGoodTempCheck vs scanDateStarted). */
        fetchCableSensorSnapshotForScan: async (output, cableId) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }
            const query = {
                query: `
                    query GetCableSensorSnapshotForScan($email: String!, $siteId: ID!, $cableId: String!) {
                        getCableSensorSnapshotForScan(email: $email, siteId: $siteId, cableId: $cableId) {
                            cableId,
                            dateRead,
                            status,
                            sensorHistories {
                                sensorId,
                                sensorName,
                                temperature,
                                lastTemperature,
                                lastGoodTempCheck
                            }
                        }
                    }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    cableId: String(cableId),
                }
            };
            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return false;
            }
        },
        /** Direct GraphQL: cable sensor history at scan time (Scan.js). */
        fetchCableSensorHistoryForScan: async (output, cableId, dateReadIso) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }
            const query = {
                query: `
                    query GetCableSensorHistory($email: String!, $siteId: ID!, $cableId: String!, $dateRead: DateTime!) {
                        getCableSensorHistory(email: $email, siteId: $siteId, cableId: $cableId, dateRead: $dateRead) {
                            cableId,
                            dateRead,
                            sensorHistories {
                                sensorId,
                                sensorName,
                                temperature,
                                lastTemperature
                            },
                            status
                        }
                    }
                    `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    cableId: cableId,
                    dateRead: dateReadIso,
                }
            };
            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return false;
            }
        },
        /** Direct GraphQL: start scan with selected cables JSON (Scan.js). */
        fetchAddScan: async (output, selectedCablesJson) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) {
                return false;
            }
            if (!global.gw.bolts && !global.gw.token) {
                return false;
            }
            const query = {
                query: `
                            mutation AddScan($email: String!, $siteId: ID!, $json: String!) {
                                addScan(email: $email, siteId: $siteId, json: $json)
                            }
                        `,
                variables: {
                    email: global.gw.email,
                    siteId: global.gw.selectedSite.siteGuid,
                    json: selectedCablesJson,
                }
            };
            try {
                return await fetchSwitch(query, output);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    throw error;
                }
                return false;
            }
        },
        fetchDiagnostic: async (output) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) return false;
            if (!global.gw.bolts && !global.gw.token) return false;
            try {
                return await fetchSwitch({
                    query: `query UserDiagnostic($email: String!, $siteId: ID!) {
                        getDiagnostic(email: $email, siteId: $siteId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                    },
                }, output);
            } catch (error) {
                if (error.response && error.response.status === 401) throw error;
                return false;
            }
        },
        fetchDiagnosticCables: async (output) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) return false;
            if (!global.gw.bolts && !global.gw.token) return false;
            try {
                return await fetchSwitch({
                    query: `query DiagnosticCables($email: String!, $siteId: ID!) {
                        getDiagnosticCables(email: $email, siteId: $siteId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                    },
                }, output);
            } catch (error) {
                if (error.response && error.response.status === 401) throw error;
                return false;
            }
        },
        fetchAddDiagnostic: async (output, json) => {
            if (!global?.gw?.email || !global.gw.selectedSite?.siteGuid) return false;
            if (!global.gw.bolts && !global.gw.token) return false;
            try {
                return await fetchSwitch({
                    query: `mutation AddDiagnostic($email: String!, $siteId: ID!, $json: String!) {
                        addDiagnostic(email: $email, siteId: $siteId, json: $json)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: global.gw.selectedSite.siteGuid,
                        json,
                    },
                }, output);
            } catch (error) {
                if (error.response && error.response.status === 401) throw error;
                return false;
            }
        },
        fetchManufacturingComponents: async (output) => {
            if (!global?.gw?.email) return null;
            try {
                return await fetchSwitch({
                    query: `query FetchManufacturingComponents($email: String!) {
                        fetchManufacturingComponents(email: $email) {
                            manufacturingComponentId
                            name
                            partNumber
                            description
                        }
                    }`,
                    variables: { email: global.gw.email },
                }, output);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        fetchManufacturedDevices: async (output) => {
            if (!global?.gw?.email) return null;
            try {
                return await fetchSwitch({
                    query: `query FetchManufacturedDevices($email: String!) {
                        fetchManufacturedDevices(email: $email) {
                            manufacturedDeviceGuid
                            name
                            description
                            manufactureDate
                            builtBy
                            dateCreated
                        }
                    }`,
                    variables: { email: global.gw.email },
                }, output);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        fetchManufacturedDevice: async (output, manufacturedDeviceId) => {
            if (!global?.gw?.email || !manufacturedDeviceId) return null;
            try {
                return await fetchSwitch({
                    query: `query FetchManufacturedDevice($email: String!, $manufacturedDeviceId: String!) {
                        fetchManufacturedDevice(email: $email, manufacturedDeviceId: $manufacturedDeviceId) {
                            manufacturedDeviceGuid
                            name
                            description
                            manufactureDate
                            builtBy
                            dateCreated
                            components {
                                manufacturingComponentId
                                componentName
                                partNumber
                                quantity
                                notes
                            }
                        }
                    }`,
                    variables: {
                        email: global.gw.email,
                        manufacturedDeviceId: String(manufacturedDeviceId),
                    },
                }, output);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        addManufacturedDevice: async (output, json) => {
            if (!global?.gw?.email) return null;
            try {
                const jsonStr = typeof json === "string" ? json : JSON.stringify(json);
                const response = await fetchSwitch({
                    query: `mutation AddManufacturedDevice($email: String!, $json: String!) {
                        addManufacturedDevice(email: $email, json: $json)
                    }`,
                    variables: { email: global.gw.email, json: jsonStr },
                }, output);
                return response?.data?.addManufacturedDevice ?? null;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        updateManufacturedDevice: async (output, json) => {
            if (!global?.gw?.email) return false;
            try {
                const jsonStr = typeof json === "string" ? json : JSON.stringify(json);
                const response = await fetchSwitch({
                    query: `mutation UpdateManufacturedDevice($email: String!, $json: String!) {
                        updateManufacturedDevice(email: $email, json: $json)
                    }`,
                    variables: { email: global.gw.email, json: jsonStr },
                }, output);
                return response?.data?.updateManufacturedDevice ?? false;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        upsertManufacturingComponent: async (output, json) => {
            if (!global?.gw?.email) return false;
            try {
                const jsonStr = typeof json === "string" ? json : JSON.stringify(json);
                const response = await fetchSwitch({
                    query: `mutation UpsertManufacturingComponent($email: String!, $json: String!) {
                        upsertManufacturingComponent(email: $email, json: $json)
                    }`,
                    variables: { email: global.gw.email, json: jsonStr },
                }, output);
                return response?.data?.upsertManufacturingComponent ?? false;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        fetchSitesCurrentlyScanning: async (output) => {
            if (!global?.gw?.email) return null;
            try {
                return await fetchSwitch({
                    query: `query FetchSitesCurrentlyScanning($email: String!) {
                        fetchSitesCurrentlyScanning(email: $email) {
                            customerSiteGuid
                            siteName
                            version
                            id
                            dateStarted
                            type
                            scanCable
                            finishedCount
                            requestedCount
                        }
                    }`,
                    variables: { email: global.gw.email },
                }, output);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        deleteCustomerSiteDirectScan: async (output, siteId, id) => {
            if (!global?.gw?.email || !siteId || id == null || id === "") return false;
            const scanId = Number(id);
            if (!Number.isFinite(scanId)) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation DeleteCustomerSiteDirectScan($email: String!, $siteId: String!, $scanId: Int!) {
                        deleteCustomerSiteDirectScan(email: $email, siteId: $siteId, scanId: $scanId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: String(siteId),
                        scanId,
                    },
                }, output);
                return response?.data?.deleteCustomerSiteDirectScan ?? false;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        fetchCustomerSiteVersions: async (output) => {
            if (!global?.gw?.email) return null;
            const variables = { email: global.gw.email };
            const withComments = `query FetchCustomerSiteVersions($email: String!) {
                        fetchCustomerSiteVersions(email: $email) {
                            versions {
                                version
                                datePublished
                                comments
                                isPublished
                            }
                            sites {
                                customerSiteGuid
                                siteName
                                version
                                getLatestVersion
                                customerSiteUpdateGuid
                                dateModified
                                reportedVersion
                                reportedVersionUtc
                            }
                        }
                    }`;
            const withoutComments = `query FetchCustomerSiteVersions($email: String!) {
                        fetchCustomerSiteVersions(email: $email) {
                            versions {
                                version
                                datePublished
                            }
                            sites {
                                customerSiteGuid
                                siteName
                                version
                                getLatestVersion
                                customerSiteUpdateGuid
                                dateModified
                                reportedVersion
                                reportedVersionUtc
                            }
                        }
                    }`;
            const legacySitesOnly = `query FetchCustomerSiteVersions($email: String!) {
                        fetchCustomerSiteVersions(email: $email) {
                            versions {
                                version
                                datePublished
                            }
                            sites {
                                customerSiteGuid
                                siteName
                                version
                                getLatestVersion
                                customerSiteUpdateGuid
                                dateModified
                            }
                        }
                    }`;
            try {
                return await fetchSwitch({ query: withComments, variables }, output);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                try {
                    // Older server schema without comments/isPublished — keep site pins working.
                    return await fetchSwitch({ query: withoutComments, variables }, output);
                } catch (fallbackError) {
                    if (fallbackError.response?.status === 401) throw fallbackError;
                    try {
                        return await fetchSwitch({ query: legacySitesOnly, variables }, output);
                    } catch (legacyError) {
                        if (legacyError.response?.status === 401) throw legacyError;
                        return null;
                    }
                }
            }
        },
        updateCustomerSiteVersion: async (output, siteId, version) => {
            if (!global?.gw?.email || !siteId || !version) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation UpdateCustomerSiteVersion($email: String!, $siteId: String!, $version: String!) {
                        updateCustomerSiteVersion(email: $email, siteId: $siteId, version: $version)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: String(siteId),
                        version: String(version),
                    },
                }, output);
                return response?.data?.updateCustomerSiteVersion ?? false;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        updateTemputechReleaseComments: async (output, version, comments) => {
            if (!global?.gw?.email || !version) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation UpdateTemputechReleaseComments($email: String!, $version: String!, $comments: String) {
                        updateTemputechReleaseComments(email: $email, version: $version, comments: $comments)
                    }`,
                    variables: {
                        email: global.gw.email,
                        version: String(version),
                        comments: comments == null ? "" : String(comments),
                    },
                }, output);
                return response?.data?.updateTemputechReleaseComments ?? false;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        deleteTemputechRelease: async (output, version) => {
            if (!global?.gw?.email || !version) {
                return { ok: false, sites: [], message: "Version is required." };
            }
            const variables = {
                email: global.gw.email,
                version: String(version),
            };
            const parseDetail = (text) => {
                const raw = String(text || "");
                if (raw === "ok") return { ok: true, sites: [], message: "" };
                if (raw.startsWith("in-use:")) {
                    const sites = raw
                        .slice("in-use:".length)
                        .split("\n")
                        .map((s) => s.trim())
                        .filter(Boolean);
                    return {
                        ok: false,
                        sites,
                        message: sites.join("; "),
                    };
                }
                if (raw.startsWith("error:")) {
                    return {
                        ok: false,
                        sites: [],
                        message: raw.slice("error:".length).trim() || "Failed to delete version.",
                    };
                }
                return { ok: false, sites: [], message: "Failed to delete version." };
            };
            try {
                const response = await fetchSwitch({
                    query: `mutation DeleteTemputechReleaseDetail($email: String!, $version: String!) {
                        deleteTemputechReleaseDetail(email: $email, version: $version)
                    }`,
                    variables,
                }, output);
                const detail = response?.data?.deleteTemputechReleaseDetail;
                if (typeof detail === "string" && detail.length > 0 && !response?.errors?.length) {
                    return parseDetail(detail);
                }
            } catch (error) {
                if (error.response?.status === 401) throw error;
            }
            try {
                const response = await fetchSwitch({
                    query: `mutation DeleteTemputechRelease($email: String!, $version: String!) {
                        deleteTemputechRelease(email: $email, version: $version)
                    }`,
                    variables,
                }, output);
                const ok = response?.data?.deleteTemputechRelease ?? false;
                return {
                    ok: Boolean(ok),
                    sites: [],
                    message: ok ? "" : "Failed to delete version.",
                };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, sites: [], message: "Failed to delete version." };
            }
        },
        deleteUnusedTemputechReleases: async (output) => {
            if (!global?.gw?.email) {
                return { ok: false, message: "Not authorized." };
            }
            try {
                const response = await fetchSwitch({
                    query: `mutation DeleteUnusedTemputechReleases($email: String!) {
                        deleteUnusedTemputechReleases(email: $email)
                    }`,
                    variables: { email: global.gw.email },
                }, output, undefined, 180000);
                const text = response?.data?.deleteUnusedTemputechReleases;
                if (typeof text !== "string" || !text || response?.errors?.length) {
                    return { ok: false, message: "Failed to remove unused versions." };
                }
                if (text.startsWith("error:")) {
                    return { ok: false, message: text.slice("error:".length).trim() || "Failed to remove unused versions." };
                }
                return { ok: true, message: text };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, message: "Failed to remove unused versions." };
            }
        },
        fetchSiteSetup: async (output, siteId, externalSignal) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) {
                return { ok: false, error: "Missing email or site id." };
            }
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), SITE_SETUP_FETCH_TIMEOUT_MS);
            const onExternalAbort = () => controller.abort();
            if (externalSignal) {
                if (externalSignal.aborted) {
                    clearTimeout(timeoutId);
                    return { ok: false, error: "Load cancelled." };
                }
                externalSignal.addEventListener("abort", onExternalAbort);
            }
            try {
                const response = await fetchSwitch({
                    query: `query FetchSiteSetup($email: String!, $siteId: String!) {
                        fetchSiteSetup(email: $email, siteId: $siteId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                    },
                }, output, controller.signal, SITE_SETUP_FETCH_TIMEOUT_MS);
                if (!response || response === false) {
                    return { ok: false, error: "Failed to load site setup (network timeout or server error)." };
                }
                if (response.errors?.length) {
                    return {
                        ok: false,
                        error: response.errors.map((e) => e.message).join(" "),
                    };
                }
                return parseSiteSetupPayload(response?.data?.fetchSiteSetup ?? null);
            } catch (error) {
                if (error.response?.status === 401) throw error;
                if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                    return { ok: false, error: "Timed out loading site setup (120s)." };
                }
                return { ok: false, error: error.message || "Network error loading site setup." };
            } finally {
                clearTimeout(timeoutId);
                if (externalSignal) {
                    externalSignal.removeEventListener("abort", onExternalAbort);
                }
            }
        },
        saveSiteSetup: async (output, siteId, setup) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !setup) return null;
            try {
                const jsonBuffer = await global.compress(JSON.stringify(setup), "gzip");
                const jsonCompressed = global.arrayBufferToBase64String(jsonBuffer);
                const response = await fetchSwitch({
                    query: `mutation SaveSiteSetup($email: String!, $siteId: String!, $json: String!, $removeHistory: Boolean!) {
                        saveSiteSetup(email: $email, siteId: $siteId, json: $json, removeHistory: $removeHistory)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                        json: jsonCompressed,
                        removeHistory: false,
                    },
                }, output);
                if (!response || response === false || response.errors?.length) return null;
                return response?.data?.saveSiteSetup ?? null;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        // Site Setup → Config Setup: read the site's server-authoritative operational config (empty until seeded).
        fetchSiteConfig: async (output, siteId) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) return "";
            try {
                const response = await fetchSwitch({
                    query: `query FetchSiteConfig($email: String!, $siteId: String!) {
                        getSiteConfig(email: $email, siteId: $siteId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                    },
                }, output);
                if (!response || response === false || response.errors?.length) return "";
                return response?.data?.getSiteConfig ?? "";
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return "";
            }
        },
        // Site Setup → Device row → Apply (Heltec only). Rebuilds HeltecSensorMapping for the one gateway,
        // merges the per-device block into SiteConfig.ConfigJson (bumps revision), and queues an
        // apply_config downlink via ChirpStack. Returns the JSON HeltecDeviceConfigApplyResult string from
        // the server, or null on auth failure. Save Setup already does this for every Heltec device.
        applyHeltecDeviceConfig: async (output, siteId, deviceUniqueId) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !deviceUniqueId) return null;
            try {
                const response = await fetchSwitch({
                    query: `mutation ApplyHeltecDeviceConfig($email: String!, $siteId: String!, $deviceUniqueId: Int!) {
                        applyHeltecDeviceConfig(email: $email, siteId: $siteId, deviceUniqueId: $deviceUniqueId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                        deviceUniqueId: Number(deviceUniqueId),
                    },
                }, output);
                if (!response || response === false || response.errors?.length) return null;
                return response?.data?.applyHeltecDeviceConfig ?? null;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return null;
            }
        },
        // Site Setup → Config Setup: save the site's config; the gateway merges it on its next poll.
        saveSiteConfig: async (output, siteId, contents) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation SaveSiteConfig($email: String!, $siteId: String!, $json: String!) {
                        saveSiteConfig(email: $email, siteId: $siteId, json: $json)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                        json: contents ?? "",
                    },
                }, output);
                if (!response || response === false || response.errors?.length) return false;
                return response?.data?.saveSiteConfig === true;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        // Admin Remote window. List never includes the password.
        fetchRemoteAccess: async (output) => {
            if (!global?.gw?.email) return { ok: false, error: "not signed in", rows: [] };
            try {
                const response = await fetchSwitch({
                    query: `query GetRemoteAccess($email: String!) { getRemoteAccess(email: $email) }`,
                    variables: { email: global.gw.email },
                }, output);
                if (!response || response === false || response.errors?.length) {
                    return { ok: false, error: "request failed", rows: [] };
                }
                const text = response?.data?.getRemoteAccess ?? "";
                return text ? JSON.parse(text) : { ok: false, error: "empty response", rows: [] };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, error: error?.message || "request failed", rows: [] };
            }
        },
        saveRemoteAccess: async (output, record) => {
            if (!global?.gw?.email) return { ok: false, error: "not signed in" };
            try {
                const response = await fetchSwitch({
                    query: `mutation SaveRemoteAccess($email: String!, $json: String!) {
                        saveRemoteAccess(email: $email, json: $json)
                    }`,
                    variables: { email: global.gw.email, json: JSON.stringify(record ?? {}) },
                }, output);
                if (!response || response === false || response.errors?.length) {
                    return { ok: false, error: "request failed" };
                }
                const text = response?.data?.saveRemoteAccess ?? "";
                return text ? JSON.parse(text) : { ok: false, error: "empty response" };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, error: error?.message || "request failed" };
            }
        },
        deleteRemoteAccess: async (output, id) => {
            if (!global?.gw?.email || !id) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation DeleteRemoteAccess($email: String!, $id: String!) {
                        deleteRemoteAccess(email: $email, id: $id)
                    }`,
                    variables: { email: global.gw.email, id: String(id) },
                }, output);
                if (!response || response === false || response.errors?.length) return false;
                return response?.data?.deleteRemoteAccess === true;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        connectRemoteAccess: async (output, id) => {
            if (!global?.gw?.email || !id) return { ok: false, error: "save this computer first" };
            try {
                const response = await fetchSwitch({
                    query: `mutation ConnectRemoteAccess($email: String!, $id: String!) {
                        connectRemoteAccess(email: $email, id: $id)
                    }`,
                    variables: { email: global.gw.email, id: String(id) },
                }, output);
                if (!response || response === false || response.errors?.length) {
                    return { ok: false, error: "request failed" };
                }
                const text = response?.data?.connectRemoteAccess ?? "";
                return text ? JSON.parse(text) : { ok: false, error: "empty response" };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, error: error?.message || "request failed" };
            }
        },
        // Queue or clear a single one-shot command without rewriting the rest of SiteConfig.
        setSiteConfigOneShot: async (output, siteId, key, json) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId || !key) return false;
            try {
                const response = await fetchSwitch({
                    query: `mutation SetSiteConfigOneShot($email: String!, $siteId: String!, $key: String!, $json: String!) {
                        setSiteConfigOneShot(email: $email, siteId: $siteId, key: $key, json: $json)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                        key,
                        json: json ?? "false",
                    },
                }, output);
                if (!response || response === false || response.errors?.length) return false;
                return response?.data?.setSiteConfigOneShot === true;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return false;
            }
        },
        exportSiteSetupBtsMdf: async (output, siteId, externalSignal) => {
            const effectiveSiteId = siteId || global.gw?.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteId) {
                return { ok: false, error: "Missing email or site." };
            }
            const controller = new AbortController();
            const onExternalAbort = () => controller.abort();
            if (externalSignal) {
                if (externalSignal.aborted) {
                    controller.abort();
                } else {
                    externalSignal.addEventListener("abort", onExternalAbort);
                }
            }
            const timeoutId = setTimeout(() => controller.abort(), SITE_SETUP_BTS_EXPORT_TIMEOUT_MS);
            try {
                const response = await fetchSwitch({
                    query: `query ExportSiteSetupBtsMdf($email: String!, $siteId: String!) {
                        exportSiteSetupBtsMdf(email: $email, siteId: $siteId)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId: effectiveSiteId,
                    },
                }, output, controller.signal, SITE_SETUP_BTS_EXPORT_TIMEOUT_MS);
                if (!response || response === false || response.errors?.length) {
                    const gqlError = response?.errors?.map((e) => e.message).join(" ");
                    return { ok: false, error: gqlError || "Failed to export BTS database." };
                }
                let parsed = response?.data?.exportSiteSetupBtsMdf ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try {
                        parsed = JSON.parse(parsed);
                    } catch {
                        break;
                    }
                }
                if (!parsed || typeof parsed !== "object") {
                    return { ok: false, error: "Export response was empty or invalid." };
                }
                if (!parsed.ok) {
                    return { ok: false, error: parsed.error || "Export failed." };
                }
                if (!parsed.zipBase64) {
                    return { ok: false, error: "Export did not include a zip payload." };
                }
                return {
                    ok: true,
                    fileName: parsed.fileName || "BTS.zip",
                    zipBase64: parsed.zipBase64,
                    sizeBytes: parsed.sizeBytes ?? null,
                };
            } catch (error) {
                if (error.name === "AbortError") {
                    return { ok: false, error: "Timed out exporting BTS database (10 min)." };
                }
                if (error.response?.status === 401) throw error;
                return { ok: false, error: error.message || "Network error exporting BTS database." };
            } finally {
                clearTimeout(timeoutId);
                if (externalSignal) {
                    externalSignal.removeEventListener("abort", onExternalAbort);
                }
            }
        },
        fetchCreateSiteOptions: async (output) => {
            if (!global?.gw?.email) return { customers: [], sites: [], error: "Missing email." };
            try {
                const response = await fetchSwitch({
                    query: `query FetchCreateSiteOptions($email: String!) {
                        fetchCreateSiteOptions(email: $email)
                    }`,
                    variables: { email: global.gw.email },
                }, output);
                if (!response || response === false || response.errors?.length) {
                    return { customers: [], sites: [] };
                }
                let parsed = response?.data?.fetchCreateSiteOptions ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try {
                        parsed = JSON.parse(parsed);
                    } catch {
                        break;
                    }
                }
                if (parsed?.error) return { customers: [], sites: [], error: String(parsed.error) };
                return {
                    customers: Array.isArray(parsed?.customers) ? parsed.customers : [],
                    sites: Array.isArray(parsed?.sites) ? parsed.sites : [],
                };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { customers: [], sites: [] };
            }
        },
        createSite: async (output, customerName, siteName) => {
            if (!global?.gw?.email) return { ok: false, error: "Missing email." };
            try {
                const response = await fetchSwitch({
                    query: `mutation CreateSite($email: String!, $customerName: String!, $siteName: String!) {
                        createSite(email: $email, customerName: $customerName, siteName: $siteName)
                    }`,
                    variables: {
                        email: global.gw.email,
                        customerName,
                        siteName,
                    },
                }, output);
                if (!response || response === false) {
                    return { ok: false, error: "Failed to create site (network or server error)." };
                }
                if (response.errors?.length) {
                    return { ok: false, error: response.errors.map((e) => e.message).join(" ") };
                }
                let parsed = response?.data?.createSite ?? null;
                if (parsed == null) {
                    return { ok: false, error: "Create site returned no response." };
                }
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try {
                        parsed = JSON.parse(parsed);
                    } catch {
                        break;
                    }
                }
                if (parsed?.error) return { ok: false, error: String(parsed.error) };
                const siteGuid = parsed?.siteGuid ?? parsed?.SiteGuid ?? null;
                if (!siteGuid) return { ok: false, error: "Create site did not return a site id." };
                const mainSiteName = parsed?.mainSiteName ?? parsed?.MainSiteName
                    ?? `${String(customerName || "").trim()} ${String(siteName || "").trim()}`.trim();
                return { ok: true, siteGuid, siteName: parsed?.siteName ?? siteName, mainSiteName };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, error: error.message || "Network error creating site." };
            }
        },
        /** Per-sensor cable health map (ForcedOpen + invalid-day trends). Optional inclusive yyyy-MM-dd range. */
        fetchSiteCableHealth: async (output, siteGuidParam, dateStart, dateEnd) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteGuid) {
                return { ok: false, message: "missing site" };
            }

            const query = {
                query: `
                    query FetchSiteCableHealth($email: String!, $siteId: String!, $dateStart: String, $dateEnd: String) {
                        fetchSiteCableHealth(email: $email, siteId: $siteId, dateStart: $dateStart, dateEnd: $dateEnd)
                    }
                `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                    dateStart: dateStart || null,
                    dateEnd: dateEnd || null,
                },
            };

            try {
                const response = await fetchSwitch(query, output, undefined, 180000);
                if (!response || response === false) {
                    return { ok: false, message: "No response from server." };
                }
                if (response.errors?.length) {
                    return { ok: false, message: response.errors.map((e) => e.message).join(" ") };
                }
                let parsed = response?.data?.fetchSiteCableHealth ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try {
                        parsed = JSON.parse(parsed);
                    } catch {
                        break;
                    }
                }
                if (!parsed || typeof parsed !== "object") {
                    return { ok: false, message: "Cable health returned no data." };
                }
                return parsed;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, message: error.message || "Network error loading cable health." };
            }
        },
        /** Live BTS fan on/off for 3D (TemputechService syncFanStatus). */
        fetchSiteFans: async (output, siteGuidParam) => {
            const effectiveSiteGuid = siteGuidParam || global.gw.selectedSite?.siteGuid;
            if (!global?.gw?.email || !effectiveSiteGuid) {
                return { ok: false, fans: [] };
            }
            if (!global.gw.bolts && !global.gw.token) {
                return { ok: false, fans: [] };
            }

            const query = {
                query: `
                    query FetchSiteFans($email: String!, $siteId: String!) {
                        fetchSiteFans(email: $email, siteId: $siteId)
                    }
                `,
                variables: {
                    email: global.gw.email,
                    siteId: effectiveSiteGuid,
                },
            };

            try {
                const response = await fetchSwitch(query, output);
                if (!response || response === false) {
                    return { ok: false, fans: [] };
                }
                if (response.errors?.length) {
                    return { ok: false, fans: [], message: response.errors.map((e) => e.message).join(" ") };
                }
                let parsed = response?.data?.fetchSiteFans ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try {
                        parsed = JSON.parse(parsed);
                    } catch {
                        break;
                    }
                }
                if (!parsed || typeof parsed !== "object") {
                    return { ok: false, fans: [] };
                }
                if (!Array.isArray(parsed.fans)) parsed.fans = [];
                return parsed;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { ok: false, fans: [], message: error.message || "Network error loading fans." };
            }
        },
        fetchCcrSiteIds: async (output) => {
            if (!global?.gw?.email) return [];
            try {
                const response = await fetchSwitch({
                    query: `query FetchCcrSiteIds($email: String!) {
                        fetchCcrSiteIds(email: $email)
                    }`,
                    variables: { email: global.gw.email },
                }, output);
                if (!response || response === false || response.errors?.length) return [];
                let parsed = response?.data?.fetchCcrSiteIds ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try { parsed = JSON.parse(parsed); } catch { break; }
                }
                return Array.isArray(parsed?.siteIds) ? parsed.siteIds : [];
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return [];
            }
        },
        fetchCcrAssetList: async (output, siteId) => {
            if (!global?.gw?.email || !siteId) return { error: "Missing site.", assets: [] };
            try {
                const response = await fetchSwitch({
                    query: `query FetchCcrAssetList($email: String!, $siteId: String!) {
                        fetchCcrAssetList(email: $email, siteId: $siteId)
                    }`,
                    variables: { email: global.gw.email, siteId },
                }, output);
                if (!response || response === false) return { error: "Could not load parts.", assets: [] };
                if (response.errors?.length) return { error: response.errors.map((e) => e.message).join(" "), assets: [] };
                let parsed = response?.data?.fetchCcrAssetList ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try { parsed = JSON.parse(parsed); } catch { break; }
                }
                if (!parsed || typeof parsed !== "object") return { error: "Could not load parts.", assets: [] };
                if (!Array.isArray(parsed.assets)) parsed.assets = [];
                return parsed;
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { error: error.message || "Could not load parts.", assets: [] };
            }
        },
        fetchCcrInstrument: async (output, siteId, assetTag) => {
            if (!global?.gw?.email || !siteId) return { error: "Missing site." };
            try {
                const response = await fetchSwitch({
                    query: `query FetchCcrInstrument($email: String!, $siteId: String!, $assetTag: String!) {
                        fetchCcrInstrument(email: $email, siteId: $siteId, assetTag: $assetTag)
                    }`,
                    variables: { email: global.gw.email, siteId, assetTag: assetTag || "" },
                }, output);
                if (!response || response === false) return { error: "Could not load the CCR record." };
                if (response.errors?.length) return { error: response.errors.map((e) => e.message).join(" ") };
                let parsed = response?.data?.fetchCcrInstrument ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try { parsed = JSON.parse(parsed); } catch { break; }
                }
                return parsed && typeof parsed === "object" ? parsed : { error: "Could not load the CCR record." };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { error: error.message || "Could not load the CCR record." };
            }
        },
        saveCcrInstrument: async (output, siteId, body) => {
            if (!global?.gw?.email || !siteId) return { error: "Missing site." };
            try {
                const response = await fetchSwitch({
                    query: `mutation SaveCcrInstrument($email: String!, $siteId: String!, $json: String!) {
                        saveCcrInstrument(email: $email, siteId: $siteId, json: $json)
                    }`,
                    variables: {
                        email: global.gw.email,
                        siteId,
                        json: JSON.stringify(body || {}),
                    },
                }, output);
                if (!response || response === false) return { error: "Could not save the CCR record." };
                if (response.errors?.length) return { error: response.errors.map((e) => e.message).join(" ") };
                let parsed = response?.data?.saveCcrInstrument ?? null;
                for (let depth = 0; depth < 3 && typeof parsed === "string"; depth += 1) {
                    try { parsed = JSON.parse(parsed); } catch { break; }
                }
                return parsed && typeof parsed === "object" ? parsed : { error: "Could not save the CCR record." };
            } catch (error) {
                if (error.response?.status === 401) throw error;
                return { error: error.message || "Could not save the CCR record." };
            }
        },
    };
};
